import PropTypes from "prop-types"
import React from "react"
import { useTranslation } from "react-i18next"
import MixedChartTemplate from "views/molecules/charts/template/MixedChartTemplate"
import { useAppContext } from "components/AppContext"
import { useEntity } from "hooks/useAxios"
import useRequest from "hooks/useRequest"
import ScoreEntity from "services/entities/ScoreEntity"
import Loading from "components/widgets/Loading"

const ChartODD13GHGEmissionsBreakdownPurchasesByProviderMolecule = () => {
  const { t } = useTranslation()
  const translationPrefix = `score:score.13.purchaseChartGHGBreakdownByProvider`
  const { currentNode, currentPeriod } = useAppContext()
  const scoreEntity = useEntity(ScoreEntity)
  const { data, isLoading, reload } = useRequest(
    () => scoreEntity.getOdd13GhgEmissionsBreakdownByProvider(),
    [currentNode, currentPeriod],
    {
      condition: !!currentNode && currentNode?.has_purchases,
      cacheKey: `odd13-provider-${currentNode?.id}-${currentPeriod?.id}`,
    }
  )
  if (isLoading) {
    return <Loading />
  }

  if (!data) return null

  const { barData, barLabels, barUnit, lineData, lineLabels, lineUnit } =
    data.datasets

  const label_keys = data.label_keys.map((key) =>
    key === "N/A" ? t(`${translationPrefix}.other`) : key
  )

  return (
    <MixedChartTemplate
      title={t(`${translationPrefix}.title`)}
      labelKeys={label_keys}
      leftDataInputs={lineData}
      leftDataBarTitle={t(`${translationPrefix}.labels.${lineLabels}`)}
      leftUnitPath={"units:units.emission_per_euro"}
      leftUnitKey={lineUnit}
      rightDataInputs={barData}
      rightDataBarTitle={t(`${translationPrefix}.labels.${barLabels}`)}
      rightUnitPath={"units:units.emission"}
      rightUnitKey={barUnit}
      helpText={t(`${translationPrefix}.help`)}
      cutLabels={{ maxLength: 15, visibleChars: 15 }}
    />
  )
}

export default ChartODD13GHGEmissionsBreakdownPurchasesByProviderMolecule
